import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALITEMTEMPLATE_LOAD,
    ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID,

    ACTION_TRIALITEMTEMPLATE_SAVE,

    ACTION_TRIALITEMTEMPLATE_CREATE,

    ACTION_TRIALITEMTEMPLATE_VALIDATE,

    ITrialItemTemplateLoadAction,
    ITrialItemTemplateLoadByIdAction,
    ITrialItemTemplateLoadFailureAction,
    ITrialItemTemplateLoadSuccessAction,

    ITrialItemTemplateSaveAction,
    ITrialItemTemplateSaveSuccessAction,
    ITrialItemTemplateSaveFailureAction,

    ITrialItemTemplateCreateAction,
    ITrialItemTemplateCreateSuccessAction,
    ITrialItemTemplateCreateFailureAction,

    ITrialItemTemplateValidateAction,
    ITrialItemTemplateValidateSuccessAction,
    ITrialItemTemplateValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialItemTemplate";
import { trialItemTemplatesApi } from "../services/trialItemTemplates";


export const
    getTrialItemTemplatesEpic = (action$): Observable<ITrialItemTemplateLoadSuccessAction | ITrialItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMTEMPLATE_LOAD)
            .mergeMap((action: ITrialItemTemplateLoadAction) => {
                return trialItemTemplatesApi
                    .getTrialItemTemplates(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialItemTemplates, response.trialItemsByCategory, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialItemTemplatesByIdEpic = (action$): Observable<ITrialItemTemplateLoadSuccessAction | ITrialItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID)
            .mergeMap((action: ITrialItemTemplateLoadByIdAction) => {
                return trialItemTemplatesApi
                    .getTrialItemTemplateById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialItemTemplate, undefined, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialItemTemplateEpic = (action$): Observable<ITrialItemTemplateSaveSuccessAction | ITrialItemTemplateSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMTEMPLATE_SAVE)
            .mergeMap((action: ITrialItemTemplateSaveAction) => {
                return trialItemTemplatesApi
                    .setTrialItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialItemTemplateEpic = (action$): Observable<ITrialItemTemplateCreateSuccessAction | ITrialItemTemplateCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMTEMPLATE_CREATE)
            .mergeMap((action: ITrialItemTemplateCreateAction) => {
                return trialItemTemplatesApi
                    .createTrialItemTemplate(action.trialId)
                    .map(response =>
                        CreateSuccess(response.trialItemTemplate, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialItemTemplateEpic = (action$): Observable<ITrialItemTemplateValidateSuccessAction | ITrialItemTemplateValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMTEMPLATE_VALIDATE)
            .mergeMap((action: ITrialItemTemplateValidateAction) => {
                return trialItemTemplatesApi
                    .validateTrialItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }